<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :title="$t('analytics.insights.recruitment_process.interviewers_interviews.title').toString()"
            :description="$t('analytics.insights.recruitment_process.interviewers_interviews.description').toString()"
        />
        <div>
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"/>
            </div>
            <div v-else>
                <div v-if="seriesDataLength > 1">
                    <custom-legend
                        :items="tabs"
                        :colors="tabs.map(tab => getTabColor(tab))"
                        :clickable="true"
                        :selected-tab="selectedTab"
                        @update="handleUpdateChart"
                        :parent-ref="graphRef"
                        :translation-key="translationKey"
                    />
                    <div class="h-full relative z-10">
                        <apexchart
                            ref="interviewersInterview"
                            :options="chartOptions"
                            :series="series"
                            :height="75 + seriesDataLength * 30"
                            type="bar"
                            width="100%"
                        />
                        <pagination
                            v-if="totalPages > 1"
                            :items-per-page="defaultDataThreshold"
                            :total-items="graphData.count"
                            @next="currentPage++"
                            @prev="currentPage--"
                            @go-to="currentPage = $event + 1"
                        />
                    </div>
                </div>
                <div v-else class="flex flex-col px-10">
                    <span class="text-center italic my-16">{{ $t('analytics.empty_series') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as analytics from "../../services/AnalyticsService";
import analyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle.vue";
import VueApexCharts from 'vue-apexcharts';
import chartOptions from '../../config/apex-charts';
import Loading from "../ui/Loading.vue";
import CustomLegend from "./CustomLegend.vue";
import Pagination from "../navigation/FlatPagination.vue";

export default {
    name: "InterviewsInterviewer",
    components: {
        CustomLegend,
        Loading,
        GraphTitle,
        'apexchart': VueApexCharts,
        Pagination,
    },
    mixins: [analyticsMixins],
    props: {
        filterFields: {type: Object},
    },
    data() {
        return {
            chartOptions: {
                ...chartOptions,
                chart: {
                    ...chartOptions.chart,
                    stacked: true,
                },
                plotOptions: {
                    ...chartOptions.plotOptions,
                    bar: {
                        ...chartOptions.plotOptions.bar,
                        borderRadius: 0,
                        barHeight: '60%',
                    }
                },
                colors: ['#00E396', '#008FFB'],
                xaxis: {
                    ...chartOptions.xaxis,
                    categories: [],
                },
                legend: {
                    show: false,
                }
            },
            tabs: ['required', 'optional'],
            translationKey: 'analytics.insights.recruitment_process.interviewers_interviews',
        }
    },
    methods: {
        getTabColor(tab) {
            return this.chartOptions.colors[this.tabs.indexOf(tab)];
        },
        fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            this.fetching = true;
            analytics.interviewsInterviewer(this.filterFields).then(response => {
                this.graphData = response;
            }).finally(() => this.buildChart())
        },
        buildChart() {
            this.series = this.getPageData();
            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef = this.$refs.interviewersInterview;
                this.setDownloadButtonId(this.graphRef, 'downloadChartInterviewersInterview')
            })
        },
    },
}
</script>
<style scoped>

</style>
